import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogProps,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useCallback } from "react";
import styles from "../../../styles/pages/home.module.scss";

import CloseIcon from "@mui/icons-material/Close";
import assest from "../../../json/assest";
import SinglePurchasedVideoTableData from "./Fragments/SinglePurchasedVideoTableData";
// import TabPanel from "@/components/UtilitiesComponent/TabPanel";
import SingleTabLabel from "./Fragments/SingleTabLabel";
// import GlobalDialogTransition from "@/components/UtilitiesComponent/GlobalDialogTransition";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import TabPanel from "../../UtilitiesComponent/TabPanel";
import GlobalDialogTransition from "../../UtilitiesComponent/GlobalDialogTransition";
import DashboardPurchasedWebsiteOnly from "../Videos/DashboardPurchasedWebsiteOnly";
import DashboardPurchasedAllPlatForm from "../Videos/DashboardPurchasedAllPlatForm";

// type AllPurchasedVideosProps = DialogProps & {};
const PurchasedVideoModal = (props) => {
  const { value, setValue, onClose, ...rest } = props;

  // const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  return (
    <Dialog
      fullScreen
      {...rest}
      onClose={handleClose}
      className="all-purchased-videos"
      TransitionComponent={GlobalDialogTransition}
    >
      <AppBar sx={{ position: "relative" }} className={styles.header_modal}>
        <Button
          autoFocus
          color="inherit"
          className={`${styles.modal_cross_icon} ${styles.modal_cross_icon_innerpg}`}
          onClick={handleClose}
        >
          <CloseIcon />
        </Button>
      </AppBar>

      <Box className={`${styles.modal_main_body} ${styles.modal_main_dscntsdd}`}>
        <Box className={`${styles.dashbrdContent_box} ${styles.dashbrdContent_boxWebPlatform}`}>
          <Box className="dashboardAllTable dashboardAllTableTab">
            {/* <PerfectScrollbar> */}
              <Box className="commonTableTab">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  className="commonTableTabBox"
                >
                  {/* <Tab
                    label={
                      <SingleTabLabel
                        title="Pending Videos"
                        count={150}
                        icon={assest.pendingIcon}
                      />
                    }
                  /> */}
                  <Tab
                    label={
                      <SingleTabLabel
                        title="All-platform"
                        count={150}
                        icon={assest.allPlatfromIcon}
                      />
                    }
                  />
                  <Tab
                    label={
                      <SingleTabLabel
                        title="Website only"
                        count={150}
                        icon={assest.globalIcon}
                      />
                    }
                  />
                  {/* <Tab
                    label={
                      <SingleTabLabel
                        title="Duplicated Videos"
                        count={150}
                        icon={assest.duplicateIcon}
                      />
                    }
                  /> */}
                </Tabs>
              </Box>

              {/* <TabPanel value={value} index={0}>
                <SinglePurchasedVideoTableData
                  hideApprovedTab
                  filterRowProps={{
                    hideLastItem: true,
                  }} />
              </TabPanel> */}

              <TabPanel value={value} index={0}>
                <DashboardPurchasedAllPlatForm />
              </TabPanel>

              <TabPanel value={value} index={1}>
                {/* <SinglePurchasedVideoTableData approvedTabName="Marked by" />
                 */}
                <DashboardPurchasedWebsiteOnly />
              </TabPanel>

              {/* <TabPanel value={value} index={2}>
                <SinglePurchasedVideoTableData
                  approvedTabName="Flagged by"
                  filterRowProps={{
                    hideLastItem: true,
                  }}
                />
              </TabPanel> */}
            {/* </PerfectScrollbar> */}
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PurchasedVideoModal;
